import { Navigate } from "react-router-dom";
import DashboardHome from "./DashboardHome";
import Login from "./login/login";
import { isStoreProductsOnlyAdmin } from "../../utils/adminAccess";

/**
 * Visiting /dashboard:
 * - If not logged in → show login form (email + password) in the main content area
 * - If logged in → show dashboard home
 */
function DashboardIndex() {
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  if (!token || token.trim() === "") {
    return <Login />;
  }

  if (isStoreProductsOnlyAdmin()) {
    return <Navigate to="/dashboard/store/products" replace />;
  }

  return <DashboardHome />;
}

export default DashboardIndex;
